type ResponseHeaderValue = string | number | boolean | readonly string[];

export function toResponseHeaderRecord(
    rawHeaders: Readonly<
        Record<string, ResponseHeaderValue | object | null | undefined>
    >,
): Record<string, string> {
    const headers: Record<string, string> = {};
    for (const [key, rawValue] of Object.entries(rawHeaders)) {
        const value = toResponseHeaderValue(rawValue);
        if (value !== null) {
            headers[key.toLowerCase()] = value;
        }
    }
    return headers;
}

function toResponseHeaderValue(
    rawValue: ResponseHeaderValue | object | null | undefined,
): string | null {
    if (
        typeof rawValue === "string" ||
        typeof rawValue === "number" ||
        typeof rawValue === "boolean"
    ) {
        return String(rawValue);
    }
    if (isStringArray(rawValue)) {
        return rawValue.join(", ");
    }
    return null;
}

function isStringArray(
    rawValue: object | null | undefined,
): rawValue is readonly string[] {
    return (
        Array.isArray(rawValue) &&
        rawValue.every((item) => typeof item === "string")
    );
}
